import Api from '@/api/Api'

export default {
  test (param) {
    return Api().get('UserAltEmail/test')
  },

  getAltEmail (param) {
    return Api().post('UserAltEmail/get_alt_email')
  },
  createAltEmail (param) {
    return Api().post('UserAltEmail/create_alt_email')
  },
  updateAltEmail (param) {
    return Api().post('UserAltEmail/update_alt_email')
  },
  deleteAltEmail (param) {
    return Api().post('UserAltEmail/delete_alt_email')
  }
}



// WEBPACK FOOTER //
// ./src/api/UserAltEmailAPI.js